import { TelemedService } from './../services/telemed.service';
import { ClonePreRegistrationUcid, ResponseCodePreRegistration } from './../models/pre-registration.model';
import { Component, OnInit, ViewChild, signal, model, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from 'src/app/shared/service/modal/modal.service';
import { LineModalTemplateService } from 'src/app/shared/service/modal/components/line-modal-template/line-modal-template.service';
import { FormVerifyCustomerService } from '../services/form-verify-customer.service';
import { ConcentService } from '../services/concent.service';
import { FormRegistrationService } from '../services/form-registration.service';
import { LoaderService } from '../services/loader.service';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { SetIdentityAction } from '../statemanagement/action/identity.action';
import { Customer, Identity, IdentityCustomerProfile } from '../models/customer.model';
import { SetCustomerAction } from '../statemanagement/action/customer.action';
import { LoggerService } from "../services/logger.service"
import { TermsAndConditionService } from '../services/terms-and-condition.service';
import { encryptData } from 'src/app/core/utilities';
import { CloneRegistrationUcid, ResponseCodeRegistration } from '../models/registration.model';
import { LineNotificationService } from '../services/line-notification.service';
import { Observable } from 'rxjs';
import { FormAdditionalServiceRegistrationService } from "../services/form-additional-service-registration.service"
import { FormPreRegistrationService } from '../services/form-pre-registration.service';
import { AddTags } from '../models/telemed.model';
import { CheckRegisterAndValidateDataReference, ResponseCheckRegisterAndValidate } from '../models/verify.model';
import { VerifyReferenceService } from '../services/verify-reference.service'
import { TelemedStateActionService } from '../statemanagement/telemed-state-action.service';
import { ActionStatusLine, ResponseStatusLine } from '../models/termAndConditionLine.model';
@Component({
    selector: 'app-daz-form',
    templateUrl: './daz-form.component.html',
    styleUrls: ['./daz-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DazFormComponent implements OnInit {

  model = model<any>({
    form: {
      idcard: { value: '', text: '' }, //0-00XX-XXXXX-00-0
      mobile: { value: '', text: '' }, //00X-XXX-X000     
    }
  });
  remarkText = signal<string>("");
  remarksGroup: {} = {
    "insure": `<b>หมายเหตุ</b><br>
    การยืนยันตัวตนนี้ เพื่อให้ท่านสามารถรับบริการหาหมอออนไลน์ รวมถึงบริการหลังการขายผ่านช่องทางไลน์ TISCO Insure ได้ หากข้อมูลไม่ถูกต้อง กรุณาติดต่อ <b>02 633 6060</b>`,
    "mazda": `หมายเหตุ : <br>
      1.การสมัครใช้บริการครั้งนี้เพื่อให้ท่านสามารถรับบริการหลังการขายผ่านช่องทางไลน์ Mazda MPI ได้สะดวกยิ่งขึ้น <br>
      2.เพื่อยกระดับการให้บริการประกันภัย ท่านจะได้รับบริการแจ้งเตือนต่างๆผ่านช่องทางไลน์ Mazda MPI ตามเบอร์โทรศัพท์มือถือที่ท่านได้ลงทะเบียนไว้`,
    "ford": `หมายเหตุ : <br>
      1.การสมัครใช้บริการครั้งนี้เพื่อให้ท่านสามารถรับบริการหลังการขายผ่านช่องทางไลน์ Ford Ensure ได้สะดวกยิ่งขึ้น <br>
      2.เพื่อยกระดับการให้บริการประกันภัย ท่านจะได้รับบริการแจ้งเตือนต่างๆผ่านช่องทางไลน์ Ford Ensure ตามเบอร์โทรศัพท์มือถือที่ท่านได้ลงทะเบียนไว้`,
    "nissan": `หมายเหตุ : <br>
      1.การสมัครใช้บริการครั้งนี้เพื่อให้ท่านสามารถรับบริการหลังการขายผ่านช่องทางไลน์ Nissan Insure ได้สะดวกยิ่งขึ้น <br>
      2.เพื่อยกระดับการให้บริการประกันภัย ท่านจะได้รับบริการแจ้งเตือนต่างๆผ่านช่องทางไลน์ Nissan Insure ตามเบอร์โทรศัพท์มือถือที่ท่านได้ลงทะเบียนไว้`
  }
  // 5 = SMS, 6=QR
  btnSubmitGroup: {} = {
    1: "ยืนยันและเพิ่มเพื่อน",
    2: "ถัดไป"
  }
  btnSubmitText = signal<string>("ยืนยัน");
  loading = signal<boolean>(true);
  subflow: string = "";
  electronicChannel = signal<number>(0);
  flagUpdate: boolean = false;
  isOpenConfirmUpdateLine = signal<boolean>(false);
  isOpenPrefill =  signal<boolean>(false);
  bg_image = "/assets/images/bg-form/#brand#-bg-verify-form-m.png";
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private verifyCustomerService: FormVerifyCustomerService,
    private concentService: ConcentService,
    private formRegistrationService: FormRegistrationService,
    private loaderService: LoaderService,
    private lineStateAction: LineStateActionService,
    private lineActionService: LineStateActionService,
    private loggerService: LoggerService,
    private termsAndConditionService: TermsAndConditionService,
    private lineNotificationService: LineNotificationService,
    private formAdditionalServiceRegistrationService: FormAdditionalServiceRegistrationService,
    private formPreRegistrationService: FormPreRegistrationService,
    private telemedService: TelemedService,
    private telemedStateActionService: TelemedStateActionService,
    private verifyReferenceService: VerifyReferenceService
  ) { }

  // subflow = 1 -> welcome call มีตอนส่ง sms ทุกช่องทาง หรือ rm -> DAZ_REDIRECT 
  // subflow = 2 -> notification มีเฉพาะ branded + ส่ง sms เท่านั้น 
  // subflow = 3 -> rm -> DAZ_REGISTER เคสที่กด ads. ของ branded มาที่ insure ซึ่งจะได้ ref_code ประกอบด้วย "ucid;register_type" เคสนี้จะมี 2 กรณีคือ
  // - กรณีลงทะเบียนแล้วจะส่ง ucid ของ 1_2312._ และ register_type = 1
  // - กรณีลงทะเบียนแบบ pre-register จะส่ง ucid ของ 1_2354._ และ register_type = 2
  async ngOnInit() {
    const channel = this.lineStateAction.channelStateInfo;
    this.bg_image = this.bg_image.replace("#brand#", channel.comCode);
    this.subflow = channel.subflow;
    this.electronicChannel.set(channel.electronic_channel || 0);

    if (channel && channel.refCode) {
      this.VerifyIdentity().then(
        isOpen => {
          if (isOpen == true) {
            console.log('redirect to verify identity');
            this.router.navigate(["../verifyIdentityForm"], { relativeTo: this.route, queryParams: { navigate: "../dazForm" } });
          }
          else {
            // channel.subflow = 1 or 3
            // if (channel.subflow != "2") {
            //   this.loading = true;
            // }
            if (channel.registerType) {
              let requestBody: CheckRegisterAndValidateDataReference = {
                // channel_identity: channel.channel_identity,
                application_channel_reference: channel.application_channel_reference,
                electronic_channel: channel.electronic_channel,
                ref_code: channel.refCode,
                register_type: channel.registerType,
                identity_id: channel.identityId
              }
              this.verifyReferenceService.apicheckRegisterAndValidateDataReference(requestBody).subscribe(
                async result => {
                  if (result) {
                    if (result.state_code == ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_SMS ||
                      result.state_code == ResponseCheckRegisterAndValidate.LEAD_EXPIRED) {
                      await this.router.navigate(['../dazFormFail'], { relativeTo: this.route, queryParams: { code: result.state_code } });
                    } else if (result.state_code == ResponseCheckRegisterAndValidate.OTHER_DEVICE ||
                      result.state_code == ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER ||
                      result.state_code == ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_PRE_REGISTER) {
                      this.isOpenConfirmUpdateLine.set(true);
                      this.loading.set(false);
                    } else {
                      // success
                      if (channel.registerType == 1 || channel.registerType == 2) {
                        // subflow 1 wc , subflow 2 noti ,subflow 3 stimulation
                        if (channel.subflow == "1" || channel.subflow == "2") {
                          console.log("add tag case register already");
                          const responseAddTags = this.addTagRef(["DAZ_TELEMED_ASSIGN_COUPON_WC"]);
                          console.log("add tag response:", responseAddTags);
                        }
                        await this.router.navigate(['../dazFormComplete'], { relativeTo: this.route, queryParams: { code: result.state_code } });
                      } else {
                        this.autoProcess();
                      }
                    }
                  }
                }
              )
            }
          }
        },
        error => {
          console.log(error);
        }
      );


    } else {
      if (channel.registerType == 3) {
        return this.router.navigate(["../application-form"], { relativeTo: this.route });
      } else {
        return this.router.navigate(["../dazFormComplete"], { relativeTo: this.route });
      }
    }
    this.setRemark(channel.comCode);
  }

  async VerifyIdentity(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const channel = this.lineActionService.channelStateInfo;
      if (channel &&
        channel.refCode.indexOf(';') == -1 &&
        channel.refCode.indexOf('-clone') == -1 &&
        channel.registerType == 3 &&
        !channel.verify_identity_token &&
        channel.subflow != "1") {
        return resolve(true);
      } else {
        return resolve(false);
      }
    })
  }

  autoProcess(update = false) {
    this.flagUpdate = update;
    const channel = this.lineStateAction.channelStateInfo;
    if (channel.refCode.split(';').length == 2) {
      console.log('auto process ref code == 2')
      this.autoRegisterInsure();
    } else {
      console.log('else auto process ref code != 2')
      const requestBody = {
        "lead_reference_number": channel.refCode
      }
      this.verifyCustomerService.apiGetLeadCustomerRegistration(requestBody).take(1).subscribe(
        async (result) => {
          if (result && result.data) {
            console.log(result.data);
            this.setDataProfile(result.data);
            if (channel.verify_identity_token) {
              this.feedData();
            } else {
              this.onSubmit();
            }
            // if (this.subflow == "1" || channel.comCode != "insure") {
            //   this.onSubmit();
            // } else {
            //   this.feedData();
            // }
            // this.feedData();
            Observable.forkJoin(this.lineActionService.observableChannel, this.lineActionService.observableIdentity, this.lineActionService.observableCustomer)
          } else {
            await this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'notfound', substatus: 'short', code: 'E00505' } });
          }
        },
        (error) => {
          console.log("get customer lead error")
          console.error(error)
        });
    }
  }

  autoRegisterInsure() {
    const channel = this.lineStateAction.channelStateInfo;
    this.loading.set(true);
    const ucid = channel.refCode.split(';')[0];
    const registerType = channel.refCode.split(';')[1];
    if (registerType == "2") {
      const payload: ClonePreRegistrationUcid = {
        ...channel,
        "ucid_lead": ucid
      }
      this.formPreRegistrationService.apiClonePreRegistrationUcid(payload).subscribe(
        async result => {

          const responseAdditional = await this.additionalServiceRegistrationTelemed(1).then(res => { console.log(res); return res; });
          if (channel.subflow == "3") {

          } else {
            let responseAddTags = null;
            if (this.subflow == "1") {
              console.log("add tag wc");
              responseAddTags = await this.addTagRef(["DAZ_TELEMED_NEW_REGISTER_WC", "DAZ_TELEMED_ASSIGN_COUPON_WC"]);
            } else {
              console.log("add tag noti");
              responseAddTags = await this.addTagRef(["DAZ_TELEMED_NEW_REGISTER_NOTI", "DAZ_TELEMED_ASSIGN_COUPON_NOTI"]);
              console.log("add tag response:", responseAddTags);
            }
          }
          this.router.navigate(["../dazFormComplete"], { relativeTo: this.route });
        },
        (error) => {
          console.log("Clone Pre-Registration Ucid error")
          console.error(error)
        });
    } else if (registerType == "1") {
      const payload: CloneRegistrationUcid = {
        ...channel,
        "app_no": +channel.appNo,
        "sub_channel": +channel.subChannel,
        "registration_application_channel": ucid
      }
      this.formRegistrationService.apiCloneRegistrationUcid(payload).subscribe(
        async result => {
          const responseAdditional = await this.additionalServiceRegistrationTelemed(1).then(res => { console.log(res); return res; });

          if (channel.subflow == "3") {

          } else {
            let responseAddTags = null;
            if (this.subflow == "1") {
              console.log("add tag wc");
              responseAddTags = await this.addTagRef(["DAZ_TELEMED_NEW_REGISTER_WC", "DAZ_TELEMED_ASSIGN_COUPON_WC"]);
            } else {
              console.log("add tag noti");
              responseAddTags = await this.addTagRef(["DAZ_TELEMED_NEW_REGISTER_NOTI", "DAZ_TELEMED_ASSIGN_COUPON_NOTI"]);
              console.log("add tag response:", responseAddTags);
            }
          }
          this.router.navigate(["../dazFormComplete"], { relativeTo: this.route });
        },
        (error) => {
          console.log("Clone Registration Ucid error")
          console.error(error)
        });
    } else {
      //error
    }
  }

  setDataProfile(data: IdentityCustomerProfile) {
    const identity = {
      "id_card": data["id_card"],
      "phone_number": data["phone_number"]
    } as Identity;
    this.lineActionService.sinkIdentity.next(new SetIdentityAction(identity))
    const customer = {
      "firstname": data["first_name"],
      "lastname": data["last_name"],
    } as Customer;
    this.lineActionService.sinkCustomer.next(new SetCustomerAction(customer));
  }

  feedData() {
    const identity = this.lineActionService.identityStateInfo;
    this.loading.set(false);
    this.isOpenPrefill.set(true);
    if (identity) {
      const current = structuredClone(this.model());
      current.form.idcard.value = identity.id_card;
      current.form.mobile.value = identity.phone_number;
      if (current.form.idcard.value && current.form.idcard.value.length == 13) {
        current.idcard.text = current.form.idcard.value.substr(0, 3) + "X".repeat(7) + current.form.idcard.value.substr(10, 3);
      }
      if (current.form.mobile.value && current.form.mobile.value.length == 10) {
        current.form.mobile.text = current.form.mobile.value.substr(0, 2) + "X".repeat(5) + current.form.mobile.value.substr(7, 3);
      }
      this.model.set(current);
    }
  }

  setButton(subflow) {
    if (subflow) {
      this.btnSubmitText.set(this.btnSubmitGroup[subflow])
    }
  }

  setRemark(comcode) {
    if (comcode) {
      this.remarkText.set(this.remarksGroup[comcode]);
    }
  }
  async onSubmit() {
    this.loading.set(true);
    const channel = this.lineStateAction.channelStateInfo;
    // this.loaderService.opendLoader();
    if (channel.comCode != "insure") {
      const responseClone = await this.clonePreRegister();
      console.log(['clone:', responseClone]);
      if (responseClone != ResponseCodePreRegistration.SUCCESS) {
        await this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: responseClone } });
      }
    }
    const responseRegister = await this.register(this.flagUpdate);
    switch (responseRegister) {
      case ResponseCodeRegistration.SUCCESS: {
        console.log("บันทึกข้อมูลสำเร็จ");
        const responseAdditional = await this.additionalServiceRegistrationTelemed(1).then(res => { console.log(res); return res; });
        let responseAddTags = null;
        if (this.subflow == "2") {
          console.log("add tag noti");
          responseAddTags = await this.addTagRef(["DAZ_TELEMED_NEW_REGISTER_NOTI", "DAZ_TELEMED_ASSIGN_COUPON_NOTI"]);
        } else {
          console.log("add tag wc");
          responseAddTags = await this.addTagRef(["DAZ_TELEMED_NEW_REGISTER_WC", "DAZ_TELEMED_ASSIGN_COUPON_WC"]);
        }
        if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == ActionStatusLine.ACCEPT &&
          channel.termsAndConditionLine.status != ResponseStatusLine.COMPLETED) {
          const isComplete = await this.createUpdateTermAndConditionLine();
          if (!isComplete) {
            this.router.navigate(["../completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
          }
        }
        console.log("add tag response:", responseAddTags);
        await this.router.navigate(["../dazFormComplete"], { relativeTo: this.route });
        break;
      }
      default: {
        await this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: responseRegister } });
      }
    }
  }

  createUpdateTermAndConditionLine(identityUcid = null): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // this.logger.info("create_or_update_success_start:")
      const channel = this.lineStateAction.channelStateInfo;
      let body = {
        comcode: channel.comCode,
        // channel_identity: channel.channel_identity,
        electronic_channel: channel.electronic_channel,
        application_channel_reference: channel.application_channel_reference,
        app_no: channel.appNo,
        term_and_condition_id: channel.termsAndConditionLine ? channel.termsAndConditionLine.termConditionId : null,
        identity_ucid: identityUcid,
      };
      this.termsAndConditionService.apiCreateOrUpdateTermsAndCondition(body).subscribe(async (result) => {
        if (result && result.response_code == "40000") {
          // this.logger.info("create_or_update_success_line: ", result);
          channel.termsAndConditionLine.status = ResponseStatusLine.COMPLETED;
          return resolve(true);
        }
        return resolve(false);
      });
    })
  }

  async addTagRef(tags: Array<string>) {
    const channel = this.lineStateAction.channelStateInfo;
    let payloadAddTags: AddTags = {
      // "channel_identity": channel.channel_identity,
      "electronic_channel": channel.electronic_channel,
      tags: []
    }
    tags.forEach(val => {
      payloadAddTags.tags.push({ "tagRef": val })
    })
    return this.telemedService.apiAddTagRef(payloadAddTags).subscribe();
  }

  additionalServiceRegistrationTelemed(registerType: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        const channel = this.lineStateAction.channelStateInfo;
        if (channel.registerFlow == "telemed") {
          const identity = this.lineStateAction.identityStateInfo;
          const { electronic_channel, channel_identity } = channel
          let phone_number = null;
          if (identity) {
            phone_number = identity.phone_number;
          }
          let body = {
            "registration_reference": phone_number,
            "electronic_channel": electronic_channel
          }
          // register type 1 = register already
          if (registerType == 1) {
            body['channel_identity'] = channel_identity;
          }
          this.formAdditionalServiceRegistrationService.apiInsert(body).subscribe(response => {
            if (response && response.state_code != "S20000") {
              return resolve(false);
            }
          });
        }
        return resolve(true);
      }
      catch (error) {
        console.error(error)
        console.log('fatal error addition service regis')
        resolve(false);
      }
    })
  }

  register(flagUpdate = false): Promise<ResponseCodeRegistration> {
    return new Promise(async (resolve, reject) => {
      const customer = this.lineStateAction.customerStateInfo;
      const identity = this.lineStateAction.identityStateInfo;
      const channel = this.lineStateAction.channelStateInfo;
      const payload: any = {
        ...customer,
        ...identity,
        ...channel,
        update_channel_identity_flag: flagUpdate
      };
      this.formRegistrationService.apiRegistration(payload).subscribe(
        async result => {
          if (!result) {
            await this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: 'E00501' } });
          }
          return resolve(result.state_code as ResponseCodeRegistration)

        }
      )
    })
  }

  clonePreRegister(): Promise<ResponseCodePreRegistration> {
    return new Promise(async (resolve, reject) => {
      const channel = this.lineStateAction.channelStateInfo;
      const payload: any = {
        ...channel,
        "lead_reference_number": channel.refCode
      };
      this.formPreRegistrationService.apiClonePreRegistration(payload).subscribe(
        async result => {
          if (!result) {
            await this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: 'E00502' } });
          }
          return resolve(result.state_code as ResponseCodePreRegistration)

        }
      )
    })
  }
  onClickConfirme() {
    this.loading.set(true);
    this.isOpenConfirmUpdateLine.set(false);
    this.autoProcess(true);
  }
  redirectToChateRoom() {
    const channel = this.lineActionService.channelStateInfo;
    window.location.href = 'https://line.me/R/oaMessage/' + channel.lineBotId
  }
}